import { createFileRoute, Outlet } from "@tanstack/react-router";
import { CreatorError, CreatorLoading } from "@/features/coworlds/navigation";

export const Route = createFileRoute("/_site/coworlds")({
  head: () => ({
    meta: [
      { title: "Manage Coworlds · Softmax" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  pendingComponent: CreatorLoading,
  errorComponent: CreatorError,
  component: Outlet,
});
